/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_optimizer_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historical performance at the upcoming circuit (where applicable)`)
};

const es_about_optimizer_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento histórico en el próximo circuito (cuando aplica)`)
};

const de_about_optimizer_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historische Leistung auf der kommenden Strecke (falls verfügbar)`)
};

const nl_about_optimizer_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historische prestaties op het aankomende circuit (waar van toepassing)`)
};

const fr_about_optimizer_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performances historiques sur le circuit à venir (le cas échéant)`)
};

const it_about_optimizer_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestazioni storiche sul circuito in programma (dove applicabile)`)
};

const pt_br2_about_optimizer_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desempenho histórico no circuito da próxima corrida (quando aplicável)`)
};

const pt_about_optimizer_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desempenho histórico no circuito seguinte (quando aplicável)`)
};

const ja_about_optimizer_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のサーキットでの過去のパフォーマンス（該当する場合）`)
};

const zh_about_optimizer_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在即将到来的赛道上的历史表现（如适用）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_optimizer_li3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_optimizer_li3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_optimizer_li3", locale)
	if (locale === "en") return en_about_optimizer_li3(inputs)
	if (locale === "es") return es_about_optimizer_li3(inputs)
	if (locale === "de") return de_about_optimizer_li3(inputs)
	if (locale === "nl") return nl_about_optimizer_li3(inputs)
	if (locale === "fr") return fr_about_optimizer_li3(inputs)
	if (locale === "it") return it_about_optimizer_li3(inputs)
	if (locale === "pt-BR") return pt_br2_about_optimizer_li3(inputs)
	if (locale === "pt") return pt_about_optimizer_li3(inputs)
	if (locale === "ja") return ja_about_optimizer_li3(inputs)
	return zh_about_optimizer_li3(inputs)
};